var lib_core = require("lib-core");

var TrayController = require("./../tray/trayController.js");

var TrayTabsModel = require("./trayTabsModel.js");
var TrayTabsView = require("./trayTabsView.js");
var TrayTabsStateMachine = require("./trayTabsStateMachine.js");
var AbstractEditorController = require("./../../abstract/abstractEditorController.js");
var Properties = require("cio-config").MetaProperties;

var TrayTabsController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);

    lib_core.GuiEvents.addEvents({
        UI_TRAY_TAB_ACTIVE_CHANGE:                   {id: 'ui_tray_tabs_01', name: "UI_TRAY_TAB_ACTIVE_CHANGE" },
        UI_TRAY_TAB_TEMPLATE_SWITCHER_BUTTON_CHANGE: {id: 'ui_tray_tabs_02', name: "UI_TRAY_TAB_TEMPLATE_SWITCHER_BUTTON_CHANGE" },
        UI_TRAY_TABS_SCROLL:                         {id: 'ui_tray_tabs_03', name: "UI_TRAY_TABS_SCROLL" },
        UI_TRAY_TABS_BOTTOM_ALMOST_REACHED:          {id: 'ui_tray_tabs_04', name: "UI_TRAY_TABS_BOTTOM_ALMOST_REACHED"},
        UI_TRAY_TABS_SEARCH_FILTERS_TOGGLED:         {id: 'ui_tray_tabs_05', name: "UI_TRAY_TABS_SEARCH_FILTERS_TOGGLED"},
        UI_TRAY_TABS_ADD_SEARCH_FILTER:              {id: 'ui_tray_tabs_06', name: "UI_TRAY_TABS_ADD_SEARCH_FILTER"},
        UI_TRAY_TABS_REMOVE_SEARCH_FILTER:           {id: 'ui_tray_tabs_07', name: "UI_TRAY_TABS_REMOVE_SEARCH_FILTER"},
        UI_TRAY_TABS_CHANGE_FILTER:                  {id: 'ui_tray_tabs_08', name: "UI_TRAY_TABS_CHANGE_FILTER" },
        UI_TRAY_TABS_SEARCHFILTER_ENTER_PRESSED:     {id: 'ui_tray_tabs_09', name: "UI_TRAY_TABS_SEARCHFILTER_ENTER_PRESSED" }
    });
};

lib_core.inherit(TrayTabsController, lib_core.Controller);
TrayTabsController.inject = {
    trayController : TrayController
};

module.exports = TrayTabsController;

TrayTabsController.prototype.afterBuild = function () {
    var self = this;

    if(this.configuration && this.configuration.tab_buttons) {
        for (var buttonname in this.configuration.tab_buttons) {
            var buttonOptions = this.configuration.tab_buttons[buttonname];
            this.getView().addButton(buttonOptions.name, buttonOptions.description, buttonOptions.icon,
                function (e, val) {
                    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.UI_TRAY_BUTTON)
                        .data('button_id', buttonOptions.id)
                        .scope(self.getModel().scope());
                    //self.model.visible(false);  // TODO: This is a violation against the basic architecture!! you cannot change model directly from the view, the view can only fire events, it's the statemachine that handles those events and needs to change the model accordingly
                    self.rootStateMachine.handle(cEvent);
                }
            );
        }
    }

    if(this.configuration && this.configuration.search_box) {
        var search_box = this.configuration.search_box;

        this.getView().addSearchbox(search_box.title, search_box.enableFiltering,
            function (e, val) {
                self.getModel().tabs.forEach(function(index, tabModel) {
                        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.UI_TRAY_TAB_SEARCH)
                            .data('parentName', self.name())
                            .data('tabName', tabModel.name())
                            .data('val', val)
                            .scope(self.getModel().scope());
                        self.getStatemachine().handle(cEvent);
                    }
                );
            }
        );
    }
};

TrayTabsController.prototype.afterLoad = function() {
    lib_core.Controller.prototype.afterLoad.call(this);
    
    var self = this,
        defaultTabExist = false;

    if(this.getModel().tabs.size() > 0) {
        if(this.configuration) {
            this.getModel().tabs.forEach(function(idx, tabModel) {
                if(tabModel.name() === self.configuration.defaultTab) {
                    defaultTabExist = true;
                }
            });
        }

        console.assert(defaultTabExist, 'Default tab in ' + this.name() + 'config does not exist. Please check the manifest.');
    }
};

TrayTabsController.prototype.createView = function () {
    return new TrayTabsView(this.getModel(), this.getStatemachine(), this.trayController.getView(), this.name());
};

TrayTabsController.prototype.createModel = function () {
    return new TrayTabsModel(this.name(), this.configuration.assetType);
};

TrayTabsController.prototype.createStateMachine = function () {
    return new TrayTabsStateMachine(this.root, this.getModel(), this.name());
};

TrayTabsController.prototype.registerTab = function (tabModel) {
    this.getModel().tabs.push(tabModel);

    //set default tab if available
    if(this.configuration) {
        if(this.configuration.defaultTab) {
            if(tabModel.name() === this.configuration.defaultTab) {
                this.getModel().activeTab(tabModel);
            }
        } else {
            //first tab added is set as default tab if no default tab name is provided in the manifest
            if(!this.getModel().activeTab()) this.getModel().activeTab(this.getModel().tabs.get(0));
        }
    }
};
